import {onBeforeMount} from 'vue';
import {CoreGraphNodeId} from '../../../../../../@polygonjs/polygonjs/src/core/graph/CoreGraph';
import {SetupLinkIndexReturn} from '../../common/LinkIndex';

import {ShaderCodePreviewPanelInitLayoutData} from '../../../../types';
export interface ShaderCodePreviewPanelProps {
	panelId: string;
	nodeId: CoreGraphNodeId;
	init_layout_data: ShaderCodePreviewPanelInitLayoutData;
}

export function SetupLayoutData(props: ShaderCodePreviewPanelProps, setupLinkIndexReturn: SetupLinkIndexReturn) {
	onBeforeMount(() => {
		fromJSON(props.init_layout_data);
	});

	function fromJSON(json: ShaderCodePreviewPanelInitLayoutData) {
		setupLinkIndexReturn.fromJSON(json);
	}

	function layoutData() {
		return {
			...setupLinkIndexReturn.toJSON(),
		};
	}

	return {fromJSON, layoutData};
}
